module.exports = __webpack_public_path__ + "static/img/crea.8aaa387.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crea.png
// module id = xmnJ
// module chunks = 0